// src/plugins/posthog.js
import posthog from "posthog-js";

export default {
	install(Vue) {
		let key,
			settings = {
				api_host: "https://us.i.posthog.com",
				capture_pageview: false
			};
		switch (window.location.hostname) {
			case "app.rankcaddy.io":
				key = "phc_RgPmOit1F5dGH5X5fr2F0RKyjgSfluWWZTXEy6NAaih";
				break;
			case "dev.rankcaddy.io":
				key = "phc_cdcTq1J2qYoSg1gtpntlB3n9occNksknG6FIcoqZM1N";
				settings.api_host = "https://eu.i.posthog.com";
				settings.person_profiles = "identified_only";
				break;
		}
		if ( key ) {
			posthog.init(key, settings);
			Vue.prototype.$posthog = posthog;
		}
	},
};